import { memo } from 'react';
import { AppTable } from 'shared/UI/UIKit/Table';
import type { OrganizationsTableProps } from './types';

export const OrganizationsTable = memo<OrganizationsTableProps>((props) => {
  return (
    <AppTable
      dataSource={props.dataSource}
      columns={props.columns}
      loading={props.loading}
      rowKey={(record) => record.id}
      pagination={props.tableState.pagination}
      sorters={props.tableState.sorters}
      className={props.className}
      onChange={props.onChange}
    />
  );
});
